/* src/components/ui/CircularProgress.jsx */
export default function CircularProgress({
    value = 0,            // 진행률 %
    strokeWidth = 8,
    label,
    className = "",
    variant = "progress",  // "progress" | "ring"
    color = "#5F9BFF",     // 진행 색 (기본 파랑)
    type,
    textsize,
}) {
    const radius = 50 - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;

    const percent = variant === "ring" ? 100 : value;
    const offset = circumference * (1 - percent / 100);


    const bgStroke = variant === "ring" ? "transparent" : "#e5e7eb";

    return (
        <div className={`relative inline-block ${className}`}>
            <svg viewBox="0 0 100 100" className="transform -rotate-90">
                {/* 배경 원 */}
                <circle
                    cx="50" cy="50" r={radius}
                    fill="transparent"
                    stroke={bgStroke}
                    strokeWidth={strokeWidth}
                />
                {/* 진행 / 링 원 */}
                <circle
                    cx="50" cy="50" r={radius}
                    fill="transparent"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 0.35s" }}
                />
            </svg>

            {/* 가운데 텍스트 */}
            {label && (
                <span className={`
                        absolute inset-0 flex items-center justify-center
                        font-bold text-gray-800
                        ${textsize ?? "text-2xl"}
                    `}
                    style={{ color: type === "today-tasks" ? '#5F9BFF' : 'black' }}
                >
                    {label}
                </span>
            )}
        </div>
    );
}
